import { Component, OnDestroy, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { HubConnection, HubConnectionBuilder } from '@microsoft/signalr';
import Enumerable from 'linq';
import { forkJoin, Observable, Subscription } from 'rxjs';
import { DefaultReconnectPolicy } from 'src/app/_helpers/signalR-retry-policy';
import { EventSummaryViewModel, LiveEventViewModel, TodaysEventViewmodel } from 'src/app/_models/generatedModels';
import { AuthenticationService } from 'src/app/_services/authentication.service';
import { EventService, SuperUserService } from 'src/app/_services/generatedServices';
declare var zE: any;

@Component({
  selector: 'bxl-mulit-viewer',
  templateUrl: 'mulit-viewer.component.html',
})
export class MulitViewerComponent implements OnInit, OnDestroy {
  initialized = false;
  events: LiveEventViewModel[] = [];
  queryRouteSubscription: Subscription;
  public connection: HubConnection;
  todaysEvents: TodaysEventViewmodel[];
  selectedEvents: number[];
  constructor(private route: ActivatedRoute, private router: Router, private eventData: EventService, private superUser: SuperUserService, private auth: AuthenticationService) {}
  ngOnDestroy(): void {
    this.queryRouteSubscription.unsubscribe();
    zE('webWidget', 'show');
  }

  ngOnInit(): void {
    this.router.routeReuseStrategy.shouldReuseRoute = () => false;
    this.loadZendesk();

    this.queryRouteSubscription = this.route.queryParamMap.subscribe((queryParam) => {
      let query = queryParam.get('eventIds');
      var eventIds = query.split(',');
      this.selectedEvents = Enumerable.from(eventIds)
        .select((x) => parseInt(x))
        .toArray();

      var subscriptions: Observable<any>[] = [];

      eventIds.forEach((eventId) => {
        subscriptions.push(this.eventData.getLiveEvent(eventId));
      });

      this.superUser.getEventsForToday().subscribe((result) => {
        this.todaysEvents = result;
      });

      forkJoin(subscriptions).subscribe((results) => {
        results.forEach((evnt) => {
          this.events.push(evnt);
        });

        console.log(this.events);
        this.InitSignalR();
      });
    });
  }

  eventChanged(evtIdx, evt) {
    console.log(this.selectedEvents);
    this.router.navigateByUrl('/live-events/multi-viewer?eventIds=' + this.selectedEvents.join());

  }

  InitSignalR(): any {
    this.connection = new HubConnectionBuilder()
      .withUrl('/liveEventHub', { accessTokenFactory: () => this.auth.getToken() })
      .withAutomaticReconnect(new DefaultReconnectPolicy())
      .build();

    this.connection.start().then(() => {
      this.events.forEach((evt) => {
        this.connection.invoke('connectToEvent', evt.id);
      });
    });

    this.connection.onreconnected(() => {
      this.events.forEach((evt) => {
        this.connection.invoke('connectToEvent', evt.id);
      });
    });
    this.initialized = true;
  }

  exitPage() {
    this.router.navigate(['/super-user/events']);
    return;
  }

  loadZendesk() {
    zE('webWidget', 'hide');
    zE('webWidget:on', 'close', () => {
      zE('webWidget', 'hide');
    });

    zE('webWidget:on', 'chat:unreadMessages', () => {
      zE('webWidget', 'show');
      zE('webWidget', 'open');
    });
  }
}
